import {Day} from 'modules/events/components/Day';
import {EmptyEventsState} from 'modules/events/components/EmptyEventsState';
import {EventsListContext} from 'modules/events/context';
import {FC, useContext} from 'react';
import style from './style.module.scss';
import {SkeletonWrapper} from 'modules/skeleton/components/SkeletonWrapper';
import {MOCK_EVENTS_GROUPED_BY_DAY} from 'modules/events/mocks';

export const DayList: FC = () => {
    const {eventsGroupedByDay, isLoading} = useContext(EventsListContext);

    if (isLoading) {
        return (
            <>
                <div className={style.main}>
                    <SkeletonWrapper className={style.skeletonWrapper}>
                        {MOCK_EVENTS_GROUPED_BY_DAY.map((day, index) => (
                            <Day dayData={day} key={index} index={index} />
                        ))}
                    </SkeletonWrapper>
                </div>
            </>
        );
    }

    if (!eventsGroupedByDay.length) {
        return <EmptyEventsState />;
    }

    return (
        <div className={style.main}>
            {eventsGroupedByDay.map((dayData, index) => {
                return <Day dayData={dayData} key={dayData.date} index={index} />;
            })}
        </div>
    );
};
